import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleForfeitTournamentEntry } from "../../api-clients/tournamentsClient";
import { showSuccessToast } from "../../utils/show-toast";

function useForfeitTournamentEntryMutation(redirectUrl?: string) {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationKey: [QUERY_KEYS.TOURNAMENT.FORFEIT_ENTRY],
    mutationFn: (entryId: string) => handleForfeitTournamentEntry(entryId),
    onSuccess: () => {
      showSuccessToast("Game Entry forfeited successfully");
      if (redirectUrl) navigate(redirectUrl);
    },
  });

  const forfeitEntry = (entryId: string) => {
    mutation.mutate(entryId);
  };

  return { mutation, forfeitEntry };
}

export default useForfeitTournamentEntryMutation;
